// removed by extract-text-webpack-plugin
module.exports = {"accordion":"ProductTabsContainer-module-accordion-31lQ1"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Product/containers/ProductTabsContainer/ProductTabsContainer.module.scss
// module id = 1276
// module chunks = 0